export default "__VITE_ASSET__ChYS6Xxv__"